import { render, staticRenderFns } from "./DrugOrderItemsRemoval.vue?vue&type=template&id=6e1cf1ec&"
import script from "./DrugOrderItemsRemoval.vue?vue&type=script&lang=js&"
export * from "./DrugOrderItemsRemoval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports